/* eslint-disable import/no-cycle */
import HttpRequest from './HttpRequest'

class ZoomProvider extends HttpRequest {
  callConnected (payload) {
    return this.post('/external/zoom/call-connected', payload, { skipLoading: true })
  }
}

export default ZoomProvider
